// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { V1Neo4jDatabaseCondition } from './V1Neo4jDatabaseCondition';
import {
  V1Neo4jDatabaseConditionFromJSON,
  V1Neo4jDatabaseConditionFromJSONTyped,
  V1Neo4jDatabaseConditionToJSON,
  V1Neo4jDatabaseConditionToJSONTyped,
} from './V1Neo4jDatabaseCondition';
import type { V1ServerPool } from './V1ServerPool';
import {
  V1ServerPoolFromJSON,
  V1ServerPoolFromJSONTyped,
  V1ServerPoolToJSON,
  V1ServerPoolToJSONTyped,
} from './V1ServerPool';
import type { V1UnifiedServerStatus } from './V1UnifiedServerStatus';
import {
  V1UnifiedServerStatusFromJSON,
  V1UnifiedServerStatusFromJSONTyped,
  V1UnifiedServerStatusToJSON,
  V1UnifiedServerStatusToJSONTyped,
} from './V1UnifiedServerStatus';
import type { V1ShowDatabasesStatus } from './V1ShowDatabasesStatus';
import {
  V1ShowDatabasesStatusFromJSON,
  V1ShowDatabasesStatusFromJSONTyped,
  V1ShowDatabasesStatusToJSON,
  V1ShowDatabasesStatusToJSONTyped,
} from './V1ShowDatabasesStatus';
import type { V1Neo4jDatabaseSettings } from './V1Neo4jDatabaseSettings';
import {
  V1Neo4jDatabaseSettingsFromJSON,
  V1Neo4jDatabaseSettingsFromJSONTyped,
  V1Neo4jDatabaseSettingsToJSON,
  V1Neo4jDatabaseSettingsToJSONTyped,
} from './V1Neo4jDatabaseSettings';
import type { V1ServerStatus } from './V1ServerStatus';
import {
  V1ServerStatusFromJSON,
  V1ServerStatusFromJSONTyped,
  V1ServerStatusToJSON,
  V1ServerStatusToJSONTyped,
} from './V1ServerStatus';
import type { V1SourceBackup } from './V1SourceBackup';
import {
  V1SourceBackupFromJSON,
  V1SourceBackupFromJSONTyped,
  V1SourceBackupToJSON,
  V1SourceBackupToJSONTyped,
} from './V1SourceBackup';
import type { V1ClusterStatus } from './V1ClusterStatus';
import {
  V1ClusterStatusFromJSON,
  V1ClusterStatusFromJSONTyped,
  V1ClusterStatusToJSON,
  V1ClusterStatusToJSONTyped,
} from './V1ClusterStatus';
import type { V1DatabasePhase } from './V1DatabasePhase';
import {
  V1DatabasePhaseFromJSON,
  V1DatabasePhaseFromJSONTyped,
  V1DatabasePhaseToJSON,
  V1DatabasePhaseToJSONTyped,
} from './V1DatabasePhase';
import type { V1RaftStatus } from './V1RaftStatus';
import {
  V1RaftStatusFromJSON,
  V1RaftStatusFromJSONTyped,
  V1RaftStatusToJSON,
  V1RaftStatusToJSONTyped,
} from './V1RaftStatus';
import type { V1RaftedCheckHealth } from './V1RaftedCheckHealth';
import {
  V1RaftedCheckHealthFromJSON,
  V1RaftedCheckHealthFromJSONTyped,
  V1RaftedCheckHealthToJSON,
  V1RaftedCheckHealthToJSONTyped,
} from './V1RaftedCheckHealth';

/**
 *
 * @export
 * @interface V1Neo4jClusterStatus
 */
export interface V1Neo4jClusterStatus {
  /**
   * Map of raft groups and their statuses
   * @type {{ [key: string]: V1ClusterStatus; }}
   * @memberof V1Neo4jClusterStatus
   */
  clusterStatuses?: { [key: string]: V1ClusterStatus };
  /**
   * Server pool status
   * @type {Array<V1ServerPool>}
   * @memberof V1Neo4jClusterStatus
   */
  desiredServerPools?: Array<V1ServerPool>;
  /**
   * Map of raft groups and their statuses
   * @type {{ [key: string]: V1RaftStatus; }}
   * @memberof V1Neo4jClusterStatus
   */
  raftStatuses?: { [key: string]: V1RaftStatus };
  /**
   * Neo4j 5-related: Status of servers based on showServers response
   * @type {Array<V1ShowDatabasesStatus>}
   * @memberof V1Neo4jClusterStatus
   */
  showDatabasesStatus?: Array<V1ShowDatabasesStatus>;
  /**
   * Neo4j 5-related: Status of servers based on showServers response
   * @type {Array<V1ServerStatus>}
   * @memberof V1Neo4jClusterStatus
   */
  showServersStatus?: Array<V1ServerStatus>;
  /**
   * ShowServersStatusLastUpdated records the time the ShowServersStatus field was last updated
   * @type {string}
   * @memberof V1Neo4jClusterStatus
   */
  showServersStatusLastUpdated?: string;
  /**
   *
   * @type {string}
   * @memberof V1Neo4jClusterStatus
   */
  systemDatabaseLeader?: string;
  /**
   * Neo4j 5 and onwards:
   * @type {Array<V1UnifiedServerStatus>}
   * @memberof V1Neo4jClusterStatus
   */
  unifiedServerStatuses?: Array<V1UnifiedServerStatus>;
  /**
   *
   * @type {V1Neo4jDatabaseSettings}
   * @memberof V1Neo4jClusterStatus
   */
  appliedSettings?: V1Neo4jDatabaseSettings;
  /**
   * Whether a backup of the system database is currently running
   * @type {boolean}
   * @memberof V1Neo4jClusterStatus
   */
  backupInProgress?: boolean;
  /**
   * +patchMergeKey=type
   * +patchStrategy=merge
   * @type {Array<V1Neo4jDatabaseCondition>}
   * @memberof V1Neo4jClusterStatus
   */
  conditions?: Array<V1Neo4jDatabaseCondition>;
  /**
   * DeploymentID records the name of the paired Neo4jDeployment created for a
   * MultiDB-Free (MultiTenant) cluster. Empty for non MultiTenant clusters.
   * @type {string}
   * @memberof V1Neo4jClusterStatus
   */
  deploymentID?: string;
  /**
   * Date of the last completed backup of the system database
   * @type {string}
   * @memberof V1Neo4jClusterStatus
   */
  lastCompletedBackupTime?: string;
  /**
   * ObservedGeneration is the latest generation observed by the controller
   * @type {number}
   * @memberof V1Neo4jClusterStatus
   */
  observedGeneration?: number;
  /**
   * Phase is the cluster lifecycle phase: Creating, Running, or Paused.
   * @type {V1DatabasePhase}
   * @memberof V1Neo4jClusterStatus
   */
  phase?: V1DatabasePhase;
  /**
   * RaftedCheckHealth tracks failures/successes of rafted status checks so that
   * transient failures do not immediately flap availability.
   * @type {V1RaftedCheckHealth}
   * @memberof V1Neo4jClusterStatus
   */
  raftedCheckHealth?: V1RaftedCheckHealth;
  /**
   * Backup that the currently running system database is based on
   * @type {V1SourceBackup}
   * @memberof V1Neo4jClusterStatus
   */
  sourceBackup?: V1SourceBackup;
  /**
   * StatefulSetIndices records the highest seen index of statefulSet for a given prefix
   * @type {{ [key: string]: number; }}
   * @memberof V1Neo4jClusterStatus
   */
  statefulSetIndices?: { [key: string]: number };
  /**
   * TotalStoreSize is a pre-aggregated total of all user+system database store sizes in this cluster,
   * rounded up to whole GiB. This exists to avoid N+1 reads of Neo4jDatabase statuses on hot paths.
   * @type {string}
   * @memberof V1Neo4jClusterStatus
   */
  totalStoreSize?: string;
}

/**
 * Check if a given object implements the V1Neo4jClusterStatus interface.
 */
export function instanceOfV1Neo4jClusterStatus(
  value: object,
): value is V1Neo4jClusterStatus {
  return true;
}

export function V1Neo4jClusterStatusFromJSON(json: any): V1Neo4jClusterStatus {
  return V1Neo4jClusterStatusFromJSONTyped(json, false);
}

export function V1Neo4jClusterStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1Neo4jClusterStatus {
  if (json == null) {
    return json;
  }
  return {
    clusterStatuses:
      json['ClusterStatuses'] == null
        ? undefined
        : mapValues(json['ClusterStatuses'], V1ClusterStatusFromJSON),
    desiredServerPools:
      json['DesiredServerPools'] == null
        ? undefined
        : (json['DesiredServerPools'] as Array<any>).map(V1ServerPoolFromJSON),
    raftStatuses:
      json['RaftStatuses'] == null
        ? undefined
        : mapValues(json['RaftStatuses'], V1RaftStatusFromJSON),
    showDatabasesStatus:
      json['ShowDatabasesStatus'] == null
        ? undefined
        : (json['ShowDatabasesStatus'] as Array<any>).map(
            V1ShowDatabasesStatusFromJSON,
          ),
    showServersStatus:
      json['ShowServersStatus'] == null
        ? undefined
        : (json['ShowServersStatus'] as Array<any>).map(V1ServerStatusFromJSON),
    showServersStatusLastUpdated:
      json['ShowServersStatusLastUpdated'] == null
        ? undefined
        : json['ShowServersStatusLastUpdated'],
    systemDatabaseLeader:
      json['SystemDatabaseLeader'] == null
        ? undefined
        : json['SystemDatabaseLeader'],
    unifiedServerStatuses:
      json['UnifiedServerStatuses'] == null
        ? undefined
        : (json['UnifiedServerStatuses'] as Array<any>).map(
            V1UnifiedServerStatusFromJSON,
          ),
    appliedSettings:
      json['appliedSettings'] == null
        ? undefined
        : V1Neo4jDatabaseSettingsFromJSON(json['appliedSettings']),
    backupInProgress:
      json['backupInProgress'] == null ? undefined : json['backupInProgress'],
    conditions:
      json['conditions'] == null
        ? undefined
        : (json['conditions'] as Array<any>).map(
            V1Neo4jDatabaseConditionFromJSON,
          ),
    deploymentID:
      json['deploymentID'] == null ? undefined : json['deploymentID'],
    lastCompletedBackupTime:
      json['lastCompletedBackupTime'] == null
        ? undefined
        : json['lastCompletedBackupTime'],
    observedGeneration:
      json['observedGeneration'] == null
        ? undefined
        : json['observedGeneration'],
    phase:
      json['phase'] == null
        ? undefined
        : V1DatabasePhaseFromJSON(json['phase']),
    raftedCheckHealth:
      json['raftedCheckHealth'] == null
        ? undefined
        : V1RaftedCheckHealthFromJSON(json['raftedCheckHealth']),
    sourceBackup:
      json['sourceBackup'] == null
        ? undefined
        : V1SourceBackupFromJSON(json['sourceBackup']),
    statefulSetIndices:
      json['statefulSetIndices'] == null
        ? undefined
        : json['statefulSetIndices'],
    totalStoreSize:
      json['totalStoreSize'] == null ? undefined : json['totalStoreSize'],
  };
}

export function V1Neo4jClusterStatusToJSON(json: any): V1Neo4jClusterStatus {
  return V1Neo4jClusterStatusToJSONTyped(json, false);
}

export function V1Neo4jClusterStatusToJSONTyped(
  value?: V1Neo4jClusterStatus | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    ClusterStatuses:
      value['clusterStatuses'] == null
        ? undefined
        : mapValues(value['clusterStatuses'], V1ClusterStatusToJSON),
    DesiredServerPools:
      value['desiredServerPools'] == null
        ? undefined
        : (value['desiredServerPools'] as Array<any>).map(V1ServerPoolToJSON),
    RaftStatuses:
      value['raftStatuses'] == null
        ? undefined
        : mapValues(value['raftStatuses'], V1RaftStatusToJSON),
    ShowDatabasesStatus:
      value['showDatabasesStatus'] == null
        ? undefined
        : (value['showDatabasesStatus'] as Array<any>).map(
            V1ShowDatabasesStatusToJSON,
          ),
    ShowServersStatus:
      value['showServersStatus'] == null
        ? undefined
        : (value['showServersStatus'] as Array<any>).map(V1ServerStatusToJSON),
    ShowServersStatusLastUpdated: value['showServersStatusLastUpdated'],
    SystemDatabaseLeader: value['systemDatabaseLeader'],
    UnifiedServerStatuses:
      value['unifiedServerStatuses'] == null
        ? undefined
        : (value['unifiedServerStatuses'] as Array<any>).map(
            V1UnifiedServerStatusToJSON,
          ),
    appliedSettings: V1Neo4jDatabaseSettingsToJSON(value['appliedSettings']),
    backupInProgress: value['backupInProgress'],
    conditions:
      value['conditions'] == null
        ? undefined
        : (value['conditions'] as Array<any>).map(
            V1Neo4jDatabaseConditionToJSON,
          ),
    deploymentID: value['deploymentID'],
    lastCompletedBackupTime: value['lastCompletedBackupTime'],
    observedGeneration: value['observedGeneration'],
    phase: V1DatabasePhaseToJSON(value['phase']),
    raftedCheckHealth: V1RaftedCheckHealthToJSON(value['raftedCheckHealth']),
    sourceBackup: V1SourceBackupToJSON(value['sourceBackup']),
    statefulSetIndices: value['statefulSetIndices'],
    totalStoreSize: value['totalStoreSize'],
  };
}
